<template>
    <div style="position:relative;">
        <el-table border :class="`x-table${config?.selectType == SelectType.SINGLE_SELECT ? ' single-select' : ''}`" ref="table" :data="datas" :scrollbar-always-on="true" :show-summary="true" :summary-method="(params)=>getSummary(params, totalSummary)" :stripe="true" :fit="true"
            width="100%" @select="selectHandler" @select-all="selectionChangeHandler"
            @header-click="sortClickHandler">
            <x-column v-for="(columnConfig, index) in config.fields" :key="index"
                :config="columnConfig" :indexFrom="indexFrom"
                @button-click="(button, row, config)=>$emit('buttonClick', button, row, config)"
                @link-click="(value, data, config)=>$emit('linkClick', value, data, config)"
            ></x-column>
        </el-table>
        <div style="position:absolute; right:0; top:0; z-index:3">
            <slot name="default"></slot>
        </div>
    </div>
</template>
<script setup>
import { defineProps, ref, watch, getCurrentInstance, onMounted } from 'vue';
import XColumn from './XColumn.vue';
import SelectType from './SelectType';
import DataPermissionManager from '../../datapermission/DataPermissionManager';
import { ElNotification } from 'element-plus';

const inst = getCurrentInstance();

const props = defineProps({
    config: { default: null },
    indexFrom: { default: 0 },
    datas: { default: null },
    selected: { default: null },
    totalSummary: { default: null },
})
// console.log(props.config,props.datas)
const summaryFields = ref(null);
watch(()=> props.config?.fields, (value)=> {
    const sfs = [];
    for (const field of value) {
        if (field.summary) sfs.push(field.field);
    }
    summaryFields.value = sfs;
})


defineEmits({
    'update:selected': null,
    'select': null,
    'selection': null,
    'buttonClick': null,
    'linkClick': null,
    'sortChanged': null,
})

const selectedRows = ref(props.selected);

watch(() => props.selected, (value) => {
    switch (props.config.selectType) {
        default:
        case SelectType.MULTIPLE_SELECT:
            if (!value) value = [];
            break;
        case SelectType.SINGLE_SELECT:
            value = value == null ? [] : [value];
            break;
        case SelectType.NO_SELECT: value = null; break;
    }
    if (!value) return;
    inst.refs.table['clearSelection']();
    value.forEach((row) => {
        inst.refs.table['toggleRowSelection'](row, true);
    })
    
})

onMounted(() => {
    let value = props.selected;
    switch (props.config.selectType) {
        default:
        case SelectType.MULTIPLE_SELECT:
            if (!value) value = [];
            break;
        case SelectType.SINGLE_SELECT:
            value = value == null ? [] : [value];
            break;
        case SelectType.NO_SELECT: value = null; break;
    }
    if (!value) return;
    inst.refs.table['clearSelection']();
    value.forEach((row) => {
        inst.refs.table['toggleRowSelection'](row, true);
    })
})

const getFields = (fields, selectType) => {
    if (!fields) fields = [];
    const fs = fields.slice();
    switch (selectType) {
        default:
        case SelectType.SINGLE_SELECT:
        case SelectType.MULTIPLE_SELECT: fs.unshift({ type: 'ListSelection', width: 40 }); break;
        case SelectType.NO_SELECT: break;
    }
    return fs;
}

const selectHandler = (rows, row) => {
    if (rows.indexOf(row) >= 0) {
        if (!DataPermissionManager.checkDataPermission(props.config?.module, row)) ElNotification(({message:'当前数据没有操作权限，操作时会被排除', title:'提示：', type:'warning'}))
        switch (props.config.selectType) {
            default:
            case SelectType.MULTIPLE_SELECT:
                inst.emit('update:selected', rows); 
                inst.emit('select', row, true);
                break;
            case SelectType.SINGLE_SELECT: 
                inst.emit('update:selected', row); 
                inst.emit('select', row, true);
                break;
            case SelectType.NO_SELECT: break;
        }
    } else {
        switch (props.config.selectType) {
            default:
            case SelectType.MULTIPLE_SELECT: 
                inst.emit('update:selected', rows); 
                inst.emit('select', row, false);
                break;
            case SelectType.SINGLE_SELECT: 
                inst.emit('update:selected', null); 
                inst.emit('select', row, false);
                break;
            case SelectType.NO_SELECT: break;
        }
    }
}
const selectionChangeHandler = (rows) => {
    // console.log('selection change', rows);
    // selectedRows.value = rows;
    if (rows.length) {
        for (const row of rows) {
            if (!DataPermissionManager.checkDataPermission(props.config?.module, row)) {
                ElNotification(({message:'部分数据没有操作权限，操作时会被排除', title:'提示：', type:'warning'}))
                break;
            }
        }
        inst.emit('selection', rows, true);
    } else inst.emit('selection', props.datas, false);
}

const sorts = ref(props.config?.sorts || []);
const sort = (field)=> {
    const f = field.field;
    let sortFields = sorts.value;
    let sortField = null;
    for (const sf of sortFields) {
        if (sf.field == f) {
            sortField = sf;
            break;
        }
    }
    if (sortField) {
        if (sortField.direction == 'DESC') sortField.direction = 'ASC';
        else {
            sortFields.splice(sortFields.indexOf(sortField), 1);
            sortField = null;
        }
    } else {
        sortField = {field:f, direction:'DESC'};
        sortFields.push(sortField)
    }
    field.sortAccord = sortField ? sortField.direction : '';
    inst.emit('sortChanged', sortFields);
}

const sortClickHandler = (column, event)=> {
    const f = column.property;
    for (const field of props.config?.fields) {
        if (field.field == f) {
            if (field.sortable) {
                sort(field);
            }
            break;
        }
    }
}

const getSummary = (params, totalSummary)=> {
    const fields = summaryFields.value;
    if (!fields || !fields.length) return [];
    const data = props.selected;
    if ((!data || !data.length) && !totalSummary) return [];
    const {columns} = params;
    const sms = [];
    // console.log('summary params', params, summaryFields.value);
    for (var i = 0; i < columns.length; i++) {
        const column = columns[i];
        let v = 0;
        let vs = '';
        if (fields.indexOf(column.property) >= 0) {
            const values = data.map((item) => Number(item[column.property]));
            for (const value of values) {
                v += isNaN(value) ? 0 : value;
            }
            vs = v.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        }
        let t = 0;
        let ts = '';
        if (totalSummary) {
            t = parseFloat(totalSummary[column.property]) || 0;
            ts = t.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        }
        let value = '';
        if (t && v) value = vs + ' / ' + ts;
        else if (v) value = vs + '';
        else if (t) value = ts + '';
        if (value) sms[i] = value;
    }
    return sms;
}

</script>
<style>
table {
    width: 100% !important;
}
.x-table {
}

.el-table--border::before, .el-table--border::after {
    display: none !important;
}

.el-table.x-table .x-button-group {
    margin-bottom: 0 !important;
}

.x-table .mx-1 {
    margin: 0 4px;
    font-size: 14px;
}

.el-table.x-table-single .x-column-header>.el-checkbox {
    display: none;
}
</style>
<style scoped>
.x-table >>> td.el-table__cell, .x-table >>> th.el-table__cell.is-leaf {
    border-right: 0 !important;
    border-left: 0 !important;
    position: relative;
}
.x-table >>> .el-table__border-left-patch {
    display: none;
}
.x-table >>> .dragger {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 1px;
    background: rgba(0, 0, 0, 0.2);
}
.x-table.single-select >>> th.x-column .el-checkbox {
    display: none;
}
</style>